import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MealPlanner from './MealPlanner';
import TrainingTracker from './TrainingTracker';
import reportWebVitals from './reportWebVitals';

// The Meal Planner and Training Tracker each open in their own browser tab
// (/meal-planner, /training), so this decides which top-level component to
// mount *before* any of them render — doing this branch inside App() itself
// would break React's rules of hooks, since App's hooks need to run in the
// same order on every render.
const isMealPlanner = window.location.pathname.startsWith('/meal-planner');
const isTraining = window.location.pathname.startsWith('/training');

// iOS reads <link rel="manifest"> and <link rel="apple-touch-icon"> from the
// DOM at the moment "Add to Home Screen" is tapped, using the manifest's
// start_url for what the icon opens (iOS 17.4+) and the touch-icon for the
// icon shown. Since all three mini-apps share one index.html, swap these to
// per-app values here so each mini-app gets its own home-screen icon/target
// instead of falling back to the site-wide default (which always opens "/").
if (isTraining) {
  document.querySelector('link[rel="manifest"]').setAttribute('href', '/manifest-training.json');
  document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', '/training-icon-180.png');
  document.title = 'Half Marathon Training';
  let appTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!appTitle) {
    appTitle = document.createElement('meta');
    appTitle.setAttribute('name', 'apple-mobile-web-app-title');
    document.head.appendChild(appTitle);
  }
  appTitle.setAttribute('content', 'Training');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isMealPlanner ? <MealPlanner /> : isTraining ? <TrainingTracker /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
